import { LOCALE_DEFAULT, countryCodeLanguageMapping } from 'src/config';

const getCountryLanguages = (countryCode = 'US') =>
  countryCodeLanguageMapping[
    countryCode.split('-')[0] as keyof typeof countryCodeLanguageMapping
  ] || [LOCALE_DEFAULT];

export default getCountryLanguages;
